import React from "react"
import { Twitter } from '@material-ui/icons';
import SendMail from '../components/SendMail';

export default function Contact() {
  return <div>
    <img
          className="h-96 m-auto w-auto md:h-48"
          src={`img/y0689.png`}
          alt="image of Contact"
      />
    <div className='text-center animate-bounce'>
      <a href="https://twitter.com/Annoske2" className='text-indigo-500 md:text-sm'>
        <Twitter/>
        <p>	Please contact to me!</p>
      </a>
    </div>
    <SendMail/>
  </div>
}
